import AddRestaurant from './AddRestaurant'
export default AddRestaurant
